var StoreWaitBoardItemModel = Backbone.Epoxy.Model.extend({
  initialize: function() { },

  defaults: {
    currentWaitTime: null,
    waitTimeMins: 0,
    clientName: null,
    employeeName: null,
    positionInLine: 0,
  },

  computeds: { },

  validation: { },

  bindModel: function(waitListInfo, index) {
    this.bindingData = true;

    var waitText = (waitListInfo.currentWaitTime == 0) ? "On Deck" : waitListInfo.currentWaitTime + "m"
    this.set('currentWaitTime', waitText);
    this.set('waitTimeMins', waitListInfo.currentWaitTime);

    this.set('clientName', waitListInfo.clientName);
    this.set('employeeName', waitListInfo.employeeName);
    this.set('positionInLine', (index + 1));
    this.set('positionInLineLabel', 'List position, ' + (index + 1));
    this.set('waitTimeMinsLabel', waitListInfo.currentWaitTime + ' minutes');

    this.bindingData = false;
  }

});

module.exports = StoreWaitBoardItemModel;
